<template>
	<v-dialog v-model="dadosCompraDialog" max-width="400">
		<PedidoWhatsApp :dialogDadosCompra="dialogWhatsApp" @dialogWhatsAppClose="dialogWhatsAppClose()" />
		<MercadoPagoDialog :dialog="dialogMercadoPago" @dialogClose="dialogMercadoPagoClose()" :empresa="empresa"
			:totalCompras="totalCompras" />
		<Card>
			<v-card-title class="pb-0 pl-0 pr-0 pt-0">
				<p class="descricaoItem ma-0 pa-0">Dados da Compra</p>
			</v-card-title>
			<v-container class="pt-0 pb-0">
				<v-progress-linear v-if="loading" indeterminate color="primary" />
				<v-row>
					<v-col sm="12" md="12" class="pl-0 pr-0">
						<v-text-field v-model="nome" label="Nome" filled dense rounded hide-details max="60"
							class="textField pa-0" />
					</v-col>
				</v-row>
				<v-row>
					<v-col sm="12" md="12" class="pl-0 pr-0 pt-0">
						<v-text-field v-model="telefone" inputmode="numeric" pattern="[0-9]*" type="text"
							v-mask="['(##)#####-####', '(##)####-####']" label="Telefone/WhatsApp" filled dense rounded
							hide-details class="textField pa-0" />
					</v-col>
				</v-row>
				<v-row v-if="empresa.usaMercadoPago  && empresa.receberNoSite == 'A'">
					<v-col class="pl-0 pr-0 pt-0">
						<v-select v-model="localPagamento" label="Como pagar?" filled dense rounded hide-details
							:items="['Pagar no site', 'Pagar na ' + (tipoEntrega == 'Retirar' ? 'loja' : 'entrega')]"
							item-text="descricao" class="textField pa-0">
							<template v-slot:selection="{ item }">
								<span class="selected">{{ item }}</span>
							</template>
						</v-select>
					</v-col>
				</v-row>
				<v-row v-if="
					(!empresa.usaMercadoPago) ||
					(empresa.usaMercadoPago && localPagamento != 'Pagar no site' && localPagamento != '')
				">
					<v-col :sm="formaPagamentoSelected == 'Dinheiro' ? '8' : '12'"
						:md="formaPagamentoSelected == 'Dinheiro' ? '8' : '12'" class="pl-0 pr-0 pt-0">
						<v-select v-model="formaPagamentoSelected" label="Forma de pagamento" filled dense rounded
							hide-details no-data-text="Nenhuma forma de pagamento disponível" :items="this.fpagamento"
							item-text="descricao" class="textField pa-0">
							<template v-slot:selection="{ item }">
								<span class="selected">{{ item.descricao }}</span>
							</template>
						</v-select>
					</v-col>
					<v-col v-if="formaPagamentoSelected == 'Dinheiro'" sm="4" md="4" class="pr-0 pt-0">
						<v-text-field v-model="troco" label="Troco para"
							v-mask="['#,##', '##,##', '###,##', '####,##', '#####,##', '######,##', '#######,##']"
							filled dense rounded hide-details class="textField pa-0">
						</v-text-field>
					</v-col>
				</v-row>
				<v-row v-if="this.retornarParcelas()">
					<v-col class="pl-0 pr-0 pt-0">
						<v-select v-model="planoPagamentoSelected" label="Parcelas" filled dense rounded hide-details
							:items="this.fpagamento.filter(
								(pagamento) => pagamento.descricao == this.formaPagamentoSelected
							)[0].fplanospagtos
								" :item-text="(item) => item.qtdParcelas + ' parcela(s)'" :item-value="(item) => item.seqinterna"
							class="textField pa-0">
							<template v-slot:selection="{ item }">
								<span class="selected">{{ item.qtdParcelas }} parcela(s)</span>
							</template>
						</v-select>
					</v-col>
				</v-row>
				<v-row v-if="showEmail()">
					<v-col sm="12" md="12" class="pl-0 pr-0 pt-0">
						<v-text-field v-model="email" label="E-mail" filled dense rounded hide-details max="120"
							class="textField pa-0" />
					</v-col>
				</v-row>
				<v-row>
					<v-col sm="12" md="12" class="pl-0 pr-0 pt-0">
						<v-text-field v-model="observacao" label="Observação" filled dense rounded hide-details
							class="textField pa-0" maxlength="120" />
					</v-col>
				</v-row>
			</v-container>
			<template v-slot:acoes>
				<Botao transparente texto="Cancelar" @clicar="dialogDadosCompraClose()" />
				<Botao color="success" :texto="localPagamento == 'Pagar no site' ? 'Pagar' : 'Confirmar'"
					@clicar="salvarPedido()" />
			</template>
		</Card>
	</v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import checkout from './checkout'
import PedidoWhatsApp from './PedidoWhatsApp.vue'
import Card from '../shared/Card.vue'
import Botao from '../shared/Botao.vue'
import MercadoPagoDialog from './MercadoPagoDialog.vue'

export default {
	props: {
		dialogDadosCompra: Boolean,
		tipoEntrega: String,
		totalCompras: Number,
	},
	components: {
		PedidoWhatsApp,
		Card,
		Botao,
		MercadoPagoDialog,
	},
	data: function () {
		return {
			nome: '',
			telefone: '',
			troco: '',
			observacao: '',
			formasDePagamentoSelector: [],
			formaPagamentoSelected: '',
			dialogWhatsApp: false,
			planoPagamentoSelected: '',
			dialogMercadoPago: false,
			localPagamento: '',
			cpf: '',
			email: '',
			loading: false,
		}
	},
	computed: {
		...mapGetters({
			endereco: 'endereco',
			dadosCompra: 'dadosCompra',
			cartProducts: 'cartProducts',
			empresa: 'empresa',
			fpagamento: 'fpagamento',
			catalogo: 'catalogo',
		}),
		dadosCompraDialog: {
			get() {
				return this.dialogDadosCompra
			},
			set() {
				this.dialogDadosCompraClose()
			},
		},
		formaPagamentoSelecionada() {
			if (this.fpagamento.length > 0)
				return this.fpagamento.filter((fpagto) => fpagto.descricao == this.formaPagamentoSelected).find(Boolean)
			return this.formasDePagamentoSelector
				.filter((fpagto) => fpagto.descricao == this.formaPagamentoSelected)
				.find(Boolean)
		},
	},
	methods: {
		click() {
			this.dialogDadosCompraClose()
		},
		retornarParcelas() {
			if (this.formaPagamentoSelected != '') {
				const parcelavel = this.fpagamento.filter(
					(pagamento) => pagamento.descricao == this.formaPagamentoSelected
				)[0]

				return parcelavel.parcelavel
			} else return false
		},
		validarCamposDadosCompra() {
			let valido = false
			if (!this.nome) {
				this.$store.dispatch('showError', 'É necessário informar o nome!')
				return valido
			}
			if (!this.telefone) {
				this.$store.dispatch('showError', 'É necessário informar o telefone!')
				return valido
			}
			if (!this.formaPagamentoSelected.length && this.localPagamento != 'Pagar no site') {
				this.$store.dispatch('showError', 'É necessário selecionar a forma de pagamento!')
				return valido
			}

			if(this.formaPagamentoSelecionada && this.formaPagamentoSelecionada.parcelavel && !this.planoPagamentoSelected) {
				this.$store.dispatch('showError', 'É necessário selecionar a quantidade de parcelas!')
				return valido
			}

			if (this.empresa.solicitarEmail == 'O') {
				if (!this.email) {
					this.$store.dispatch('showError', 'É necessário informar o e-mail!')
					return valido
				}
			}

			if (!this.validaEmail(this.email)) {
				this.$store.dispatch('showError', 'É necessário informar um e-mail válido!')
				return valido
			}

			valido = true
			return valido
		},
		dialogDadosCompraClose() {
			this.$emit('dialogDadosCompraClose')
		},
		dialogWhatsAppOpen() {
			this.dialogWhatsApp = true
			this.dialogDadosCompraClose()
		},
		dialogWhatsAppClose() {
			this.dialogWhatsApp = false
			//this.$router.replace(`/${this.catalogo.identificadorCatalogo}`)
			window.location.reload()
		},
		dialogMercadoPagoClose() {
			this.dialogMercadoPago = false
		},
		async salvarPedido() {
			if (this.validarCamposDadosCompra()) {
				const formaPagamento = this.formaPagamentoSelecionada
				this.addDadosCompra({
					nome: this.nome,
					telefone: this.telefone,
					formaPagamento: formaPagamento ? formaPagamento.descricao : 'No Site',
					fpaseqinterna: formaPagamento ? formaPagamento.seqinterna : 0,
					fplanoseqinterna: this.planoPagamentoSelected,
					troco: this.troco,
					observacao: this.observacao,
					vendedor: this.$route.query.vendedor,
					cpf: this.cpf,
					email: this.email,
				})

				if (this.localPagamento != 'Pagar no site') {
					checkout()
					this.dialogWhatsAppOpen()
				} else if (this.empresa.gatewayPagamento == 'MercadoPago' && this.empresa.mercadopagoPublicKey) this.dialogMercadoPago = true
				else {
					this.loading = true
					try {
						await checkout()
					} catch (error) {
						window.console.log(error)
						this.$store.dispatch('showError', error)
					}

				}
			}
		},
		showEmail() {
			if (this.empresa.solicitarEmail == 'S' || this.empresa.solicitarEmail == 'O') return true

			return false
		},
		validaEmail(email) {
			if(!email) return true

			let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

			return emailRegex.test(email)
		},
		...mapActions({
			addDadosCompra: 'addDadosCompra',
		}),
	},
	watch: {
		formaPagamentoSelected() {
			this.planoPagamentoSelected = ''
			this.retornarParcelas()
		},
	},
	mounted() {
		this.localPagamento =
			this.empresa.mercadopagoPublicKey && this.empresa.receberNoSite == 'S' ? 'Pagar no site' : ''
	},
}
</script>
<style scoped>
.descricaoItem {
	font-weight: bold;
	color: var(--v-primary-base);
}

.textField {
	font-weight: 600;
	border-radius: 1rem;
}

.textField>>>.v-text-field__slot input {
	color: var(--v-texto-base);
}

.theme--light.v-input input,
.theme--light.v-input textarea {
	color: var(--v-texto-base);
}

.textField>>>.theme--light.v-icon {
	color: var(--v-texto-base);
}

.selected {
	color: var(--v-texto-base);
}
</style>